<template>
  <div class="main pages-profile-calendar">
    <aside class="sidebar" role="sidebar">
      <div class="inner-sidebar">
        <div class="sidebar-header">
          <div class="bg-white p-3 text-center d-xl-none">
            <h1 class="mb-0">Manage Calendar</h1>
          </div>
        </div>
        <div class="sidebar-filters">
          <div class="custom-filters">
            <div class="inner pt-3 pt-xl-0">
              <div class="collapse-toggle d-inline-block clearfix">
                <a
                  class="d-xl-none"
                  data-toggle="collapse"
                  href="#calendar-status-filters"
                >
                  <icon icon="arrow-up" class="icon" />
                </a>
                <h4 class="mb-0">Show</h4>
              </div>
              <div class="collapse show pt-3" id="calendar-status-filters">
                <Field
                  v-for="(status, i) in statuses"
                  :key="i"
                  type="checkbox"
                  :id="`status_${status.value}`"
                  name="status[]"
                  :label="status.label"
                  v-model="selectedStatuses"
                  :checkboxValue="status.value"
                  :element-class="`status-${status.value} custom-control custom-checkbox mb-1`"
                  input-class="custom-control-input"
                  label-class="custom-control-label font-weight-normal"
                />
              </div>
              <template v-if="trainers.length > 1">
                <hr />
                <h4>View calendar for</h4>
                <Field
                  type="select"
                  name="trainer"
                  v-model="chosenTrainer"
                  :options="trainers"
                  :hide-select-empty-option="true"
                />
              </template>
            </div>
          </div>
        </div>
      </div>
    </aside>

    <div class="title-bar row no-gutters p-3 d-none d-xl-flex">
      <div class="col-6">
        <h1>Manage Calendar</h1>
      </div>
      <div class="col-6 text-right">
        <a class="btn btn-info" href="#" @click.prevent="createMessage()">
          <span class="icon icon-courses"/>
          <span class="text">Add Message Block</span>
        </a>
        <a class="btn btn-info" href="#" @click.prevent="createBlockout()">
          <span class="icon icon-plus"/>
          <span class="text">Add Busy Block</span>
        </a>
      </div>
    </div>

    <div class="content">
      <div class="row no-gutters">
        <div class="col-12">
          <transition name="fade">
            <Alert v-if="hasAlert" :alert="alert" />
          </transition>
          <div class="calendar-header row no-gutters">
            <div class="col-6 py-3 col-xl-12">
              <div class="calendar-pagination pl-2 text-xl-center">
                <a
                  class="d-inline-block mr-2 mr-xxl-3"
                  href="#"
                  @click.prevent="prevMonth()"
                >
                  <icon icon="arrow-left" class="icon prev" />
                </a>
                <span class="text d-inline-block">{{
                  selectedMonth | moment("MMMM YYYY")
                }}</span>
                <a
                  class="d-inline-block ml-2 ml-xxl-3"
                  href="#"
                  @click.prevent="nextMonth()"
                >
                  <icon icon="arrow-right" class="icon next" />
                </a>
              </div>
            </div>
            <div class="col-6 py-3 text-right d-xl-none">
              <a
                  class="pr-3"
                  href="#"
                  title="Add Message Block"
                  @click.prevent="createMessage()"
              >
                <icon class="icon icon-courses" icon="courses"/>
              </a>
              <a
                  class="add-blockout-button pr-3"
                  href="#"
                  title="Add Busy Block"
                  @click.prevent="createBlockout()"
              >
                <icon class="icon" icon="remove"/>
              </a>
            </div>
          </div>
          <div class="row no-gutters">
            <div class="col-12 col-md-6 col-xxl-12 p-xxl-4 calendar-wrap">
              <Calendar
                :month="selectedMonth"
                :selected="selectedDay"
                @day-selected="daySelected"
              >
                <template v-slot:day="{ day }">
                  <span class="date">{{ day }}</span>
                  <div
                    v-if="hasEventsOnDay(day)"
                    class="bullet text-primary d-xxl-none"
                  >
                    &bull;
                  </div>
                  <div
                    v-if="hasEventsOnDay(day)"
                    class="events d-none d-xxl-block"
                  >
                    <a
                      v-for="(item, i) in items[day]"
                      :key="i"
                      href="#"
                      @click.prevent="itemClicked(item)"
                      class="event-item"
                      :class="item.type"
                    >
                      <span class="text">{{ item.label }}</span>
                    </a>
                  </div>
                </template>
              </Calendar>
            </div>
            <div class="col-12 col-md-6 d-xxl-none events-list">
              <template v-if="eventList.length > 0">
                <div
                  v-for="(item, i) in eventList"
                  :key="i"
                  class="event-item"
                  :class="item.type"
                >
                  <div v-if="!!item.start_time && !!item.end_time" class="time">
                    <div class="start">
                      {{ `${item.date} ${item.start_time}` | moment("h:mm A") }}
                    </div>
                    <div class="end">
                      {{ `${item.date} ${item.end_time}` | moment("h:mm A") }}
                    </div>
                  </div>
                  <div v-else class="time">
                    <div class="end">ALL DAY</div>
                  </div>
                  <div class="info">
                    <h4 class="title" @click="itemClicked(item)">
                      {{ item.label }}
                    </h4>
                  </div>
                  <div class="buttons">
                    <a
                      v-if="item.type !== 'blockout'"
                      href="#"
                      @click.prevent="viewEventDetails(item)"
                      class="btn-sm btn-info"
                      >Details</a
                    >
                    <a
                      v-if="item.type === 'tentative'"
                      href="#"
                      @click.prevent="showRsvpModal(item)"
                      class="btn-sm btn-warning"
                      >RSVP</a
                    >
                    <a
                      v-if="item.type === 'blockout'"
                      href="#"
                      @click.prevent="editBlockout(item)"
                      class="btn-sm btn-danger"
                      >Edit</a
                    >
                    <a
                        v-if="item.type === 'message'"
                        class="btn-sm btn-danger"
                        href="#"
                        @click.prevent="editMessage(item)"
                    >Edit</a
                    >
                  </div>
                </div>
              </template>
              <template v-else>
                <div class="p-3">
                  <div class="alert alert-info">
                    No events scheduled for selected date
                  </div>
                </div>
              </template>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import DisplaysAlerts from "mixins/DisplaysAlerts";
import EventDetailsModal from "components/partials/Events/DetailsModal";
import RsvpModal from "./partials/EditRSVP";
import CalendarBlockoutModal from "./partials/EditCalendarBlockout";
import CalendarMessageModal from "./partials/EditCalendarMessage";

export default {
  mixins: [DisplaysAlerts],

  props: {
    defaultParams: { type: Object, default: () => {} },
    trainers: { type: Array, default: () => [] },
    selectedTrainer: { type: Object, default: () => {}},
  },

  data() {
    return {
      items: {},
      loadingTimeout: null,
      statuses: [
        { label: "Open Events", value: "open" },
        { label: "Confirmed Events", value: "confirmed" },
        { label: "Tentative Events", value: "tentative" },
        { label: "Busy", value: "blockout" },
        {label: "Message", value: "message"},
      ],
      selectedMonth: this.$moment().format("YYYY-MM"),
      selectedStatuses: [],
      selectedDay: null,
      eventBus: new Vue(),
      chosenTrainer: this.selectedTrainer.id,
    };
  },

  computed: {
    listingUrl() {
      return this.route("profile.calendar.list", {
        trainer: this.chosenTrainer,
      });
    },

    eventList() {
      if (!!this.selectedDay && this.hasEventsOnDay(this.selectedDay)) {
        return this.items[this.selectedDay];
      } else {
        return [];
      }
    },
  },

  watch: {
    selectedMonth(val) {
      this.refresh();
    },

    selectedStatuses(val) {
      if (!val || val.length === 0) {
        this.$nextTick(() => {
          this.selectedStatuses = this.statuses.map((status) => status.value);
          this.refresh();
        });
      } else {
        this.refresh();
      }
    },

    chosenTrainer(val) {
      this.refresh();
    },
  },

  methods: {
    refresh: _.debounce(function () {
      clearTimeout(this.loadingTimeout);
      this.loadingTimeout = setTimeout(() => {
        this.$root.showLoading();
      }, 1000);

      this.axios
        .get(this.listingUrl, {
          params: {
            ...{ month: this.selectedMonth },
            ...{ status: this.selectedStatuses },
          },
        })
        .then((response) => {
          this.items = response.data.results;
          clearTimeout(this.loadingTimeout);
          this.$root.hideLoading();
        })
        .catch((error) => {
          alert(error);
        });
    }, 300),

    loadParams() {
      if (_.has(this.defaultParams, "month")) {
        this.selectedMonth = this.defaultParams.month;
      }
      if (_.has(this.defaultParams, "status")) {
        this.selectedStatuses = _.cloneDeep(this.defaultParams.status);
      }
    },

    prevMonth() {
      var prev = this.$moment(this.selectedMonth)
        .subtract(1, "months")
        .format("YYYY-MM");
      this.items = {};
      this.selectedMonth = prev;
    },

    nextMonth() {
      var next = this.$moment(this.selectedMonth)
        .add(1, "months")
        .format("YYYY-MM");
      this.items = {};
      this.selectedMonth = next;
    },

    daySelected(day) {
      this.selectedDay = day;
    },

    hasEventsOnDay(day) {
      return _.has(this.items, day);
    },

    itemClicked(item) {
      if (item.type == "message") {
        this.editMessage(item);
      } else if (item.type == "blockout") {
        this.editBlockout(item);
      } else if (item.type == "tentative") {
        this.showRsvpModal(item);
      } else {
        this.viewEventDetails(item);
      }
    },

    viewEventDetails(item) {
      this.$modal(EventDetailsModal, { event: item.event })
        .then(() => {})
        .catch(() => {});
    },

    viewEventRoster(item) {
      this.$modal(EventDetailsModal, { event: item.event, tab: "roster" })
        .then(() => {})
        .catch(() => {});
    },

    showRsvpModal(item) {
      this.$modal(RsvpModal, { event: item.event })
        .then(() => {
          this.showAlert(
            "success",
            "Thank you! Your response has been recorded."
          );
          this.refresh();
        })
        .catch(() => {});
    },

    createBlockout() {
      this.$modal(CalendarBlockoutModal, {
        blockout: {
          start_date: null,
          end_date: null,
          reason: "",
        },
        eventBus: this.eventBus,
      })
        .then(this.storeBlockout)
        .catch(() => {});
    },

    storeBlockout(blockout) {
      this.axios
        .post(
          this.route("profile.calendar.blockout.store"),
          this.formatBlockoutForStorage(blockout)
        )
        .then(() => {
          this.showAlert(
            "success",
            "Your new busy block has been successfully created"
          );
          this.refresh();
        })
        .catch(() => {});
    },

    editBlockout(blockout) {
      this.$modal(CalendarBlockoutModal, {
        blockout: blockout,
        eventBus: this.eventBus,
      })
        .then(this.updateBlockout)
        .catch(() => {});
    },

    updateBlockout(blockout) {
      this.axios
        .put(
          this.route("profile.calendar.blockout.update", {
            blockout: blockout.id,
          }),
          this.formatBlockoutForStorage(blockout)
        )
        .then(() => {
          this.showAlert(
            "success",
            "Your busy block has been successfully updated"
          );
          this.refresh();
        })
        .catch(() => {});
    },

    destroyBlockout(blockout) {
      this.axios
        .delete(
          this.route("profile.calendar.blockout.destroy", {
            blockout: blockout.id,
          })
        )
        .then(() => {
          this.showAlert(
            "success",
            "Your busy block has been successfully removed"
          );
          this.refresh();
        })
        .catch(() => {});
    },

    formatBlockoutForStorage(blockout) {
      var start_date = this.$moment(blockout.start_date).format("YYYY-MM-DD");
      var end_date = this.$moment(blockout.end_date).format("YYYY-MM-DD");
      return {
        user_id: this.chosenTrainer,
        start_date: start_date,
        end_date: end_date,
        reason: blockout.reason,
      };
    },

    createMessage() {
      this.$modal(CalendarMessageModal, {
        message: {
          start_date: null,
          end_date: null,
          content: "",
        },
        eventBus: this.eventBus,
      })
          .then(this.storeMessage)
          .catch(() => {
          });
    },

    storeMessage(message) {
      this.axios
          .post(
              this.route("profile.calendar.message.store"),
              this.formatMessageForStorage(message)
          )
          .then(() => {
            this.showAlert(
                "success",
                "Your new message block has been successfully created"
            );
            this.refresh();
          })
          .catch(() => {
          });
    },

    editMessage(message) {
      this.$modal(CalendarMessageModal, {
        message: message,
        eventBus: this.eventBus,
      })
          .then(this.updateMessage)
          .catch(() => {
          });
    },

    updateMessage(message) {
      this.axios
          .put(
              this.route("profile.calendar.message.update", {
                message: message.id,
              }),
              this.formatMessageForStorage(message)
          )
          .then(() => {
            this.showAlert(
                "success",
                "Your message block has been successfully updated"
            );
            this.refresh();
          })
          .catch(() => {
          });
    },

    destroyMessage(message) {
      this.axios
          .delete(
              this.route("profile.calendar.message.destroy", {
                message: message.id,
              })
          )
          .then(() => {
            this.showAlert(
                "success",
                "Your message block has been successfully removed"
            );
            this.refresh();
          })
          .catch(() => {
          });
    },

    formatMessageForStorage(message) {
      var start_date = this.$moment(message.start_date).format("YYYY-MM-DD");
      var end_date = this.$moment(message.end_date).format("YYYY-MM-DD");
      return {
        user_id: this.chosenTrainer,
        start_date: start_date,
        end_date: end_date,
        content: message.content,
      };
    },
  },

  mounted() {
    this.loadParams();
    console.log(this.selectedTrainer.id);
    this.eventBus.$on("delete-blockout", this.destroyBlockout);
    this.eventBus.$on("delete-message", this.destroyMessage);
  },
};
</script>